import { ADDTOCART, DELETE, QTYDECREMENT, QTYINCREMENT } from "./ActionsType";

export const addToCart = (id, price) => {
  return {
    type: ADDTOCART,
    payload: {
      id,
      price
    }
  };
};

export const cartQtyIncrease = (id) => {
  return {
    type: QTYINCREMENT,
    payload: id
  };
};

export const cartQtyDecrease = (id) => {
  return {
    type: QTYDECREMENT,
    payload: id
  };
};

export const deleteCart = (id) => {
  return {
    type: DELETE,
    payload: id
  };
};
